import { useAppT } from '../localization/config'
import Wrapper from './Wrapper'

export default function Email({ shorten = false, anim = false }: { shorten?: boolean; anim?: boolean }) {
  const t = useAppT()

  return (
    <Wrapper
      wrap={!shorten}
      wrapper={(children) => (
        <p>
          {t.contact_email} {children}
        </p>
      )}
    >
      <a href="mailto:sophiamagic@seznam.cz" className={anim ? 'a-anim' : ''}>
        sophiamagic@seznam.cz
      </a>
    </Wrapper>
  )
}
